import { render, staticRenderFns } from "./DesignFormTempletModal.vue?vue&type=template&id=33064544&scoped=true&"
import script from "./DesignFormTempletModal.vue?vue&type=script&lang=js&"
export * from "./DesignFormTempletModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33064544",
  null
  
)

export default component.exports